module.exports = __webpack_public_path__ + "img/ezgif.com-optimize.bb381cfb.gif";